import React, {useState} from 'react';
import Translate from "../../../../../../../components/Translate";
import Chat from "../../../../../../../assets/images/chats.png";
import LoadingComponent from "../../../../../../../assets/LoadingComponent";
import Active from "../../../../../../../assets/images/ongoing.png";
import Cross from "../../../../../../../assets/images/cross.png";
import BotPlatformRequestTable from "../chats/BotPlatformRequestTable";


function BotStatistics({openTrModal,company}) {



    return (
      <React.Fragment>
          <div onClick={() => openTrModal('allRequestsToOperator')}
               className="statistic-card statistic-card-hoverable">
              <h2><Translate text={'allRequestsToOperator'}/></h2>
              <img style={{marginBottom: '10px'}} width={40} height={40} src={Chat}/>
              {false ? <LoadingComponent/>
                  :
                  <span className="count">{0}</span>
              }
          </div>
          <div onClick={() => openTrModal('todaysRequestsToOperator')}
               className="statistic-card statistic-card-hoverable">
              <h2><Translate text={'todaysRequestsToOperator'}/></h2>
              <img style={{marginBottom: '10px'}} width={40} height={40} src={Chat}/>
              {false ? <LoadingComponent/>
                  :
                  <span className="count">{0}</span>
              }
          </div>

          <div onClick={() => openTrModal('activeRequests', {statuses: 'OPERATOR_PROCESSING'})}
               className="statistic-card statistic-card-hoverable">
              <h2><Translate text={'activeRequests'}/></h2>
              <img style={{marginBottom: '10px'}} width={40} height={40} src={Active}/>
              {false ? <LoadingComponent/>
                  :
                  <span className="count">{0}</span>
              }
          </div>

          <div className={'statistic-card'}>
              <h2><Translate text={'forbiddenWordsReplacedCount'}/></h2>
              <img style={{marginBottom: '10px'}} width={40} height={40} src={Cross}/>
              {false ? <LoadingComponent/>
                  :
                  <span className="count">
                      {0}
                  </span>
              }
          </div>
          <div className={'statistic-card'}>
              <h2><Translate text={'offWorkingHoursAttemptCount'}/></h2>
              <img style={{marginBottom: '10px'}} width={40} height={40} src={Cross}/>
              {false ? <LoadingComponent/>
                  :
                  <span className="count">
                      {0}
                  </span>
              }
          </div>
          <div className={'statistic-card'}>
              <h2><Translate text={'blockedUserAttemptCount'}/></h2>
              <img style={{marginBottom: '10px'}} width={40} height={40} src={Cross}/>
              {false ? <LoadingComponent/>
                  :
                  <span className="count">
                      {0}
                  </span>
              }
          </div>
          <div className="statistic-card statistic-card-full-width" >
              <h2>
                  <Translate text="requestsByBotsAndPlatforms"/>
              </h2>
              {
                  company.tariff && company.tariff.messengers &&
                  <BotPlatformRequestTable
                      company={company}
                      onCellClick={openTrModal}
                  />
              }
          </div>
      </React.Fragment>
    );
}

export default BotStatistics;


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/statistics/components/bots/BotStatistics.jsx